enum Action {
    'add',
    'edit',
    'remove',
}

export default Action;
